import React, { FunctionComponent } from "react";
import { useTaxCode } from "./taxCodesApi";
import { Trans, t } from "@lingui/macro";
import { useField } from "formik";
import { useLingui } from "@lingui/react";

export interface Props {
  name: string;
}

export const EnteredTaxCodeRow: FunctionComponent<Props> = ({ name }) => {
  const { i18n } = useLingui();
  const code = name.substring(1);
  const { taxCode } = useTaxCode(code);
  const [{ value }, , { setValue }] = useField(name);

  const [, , { setValue: setHelpDialogValue }] = useField(`help.${name}`);

  const formattedValue = React.useMemo(() => {
    if (!taxCode) {
      return null;
    }
    switch (taxCode.type) {
      case "bool":
        return taxCode.default === "yes" ? <Trans>Ja</Trans> : <Trans>Nee</Trans>;
      case "pct":
        return Number(value).toFixed(2) + " %";
      case "num":
        return Number(value).toFixed(0);
      case "date":
        return value;
      default:
        return Number(value).toFixed(2) + " €";
    }
  }, [taxCode, value]);

  if (!taxCode || !formattedValue) {
    return null;
  }

  return (
    <div className="codesrow">
      <div className="colcode">{code}</div>
      <div className="colamount">{formattedValue}</div>
      <div className="coldescr">{taxCode.name}</div>
      <div className="coldel">
        <button
          title={i18n._(t`Codes verwijderen`)}
          onClick={() => {
            setValue(undefined);
            setHelpDialogValue(undefined);
          }}
          type="button"
        >
          X
        </button>
      </div>
    </div>
  );
};

EnteredTaxCodeRow.displayName = "EnteredTaxCodeRow";
